<template lang="pug">
  #app
    asset-pair-selector
    app-header
    app-main
</template>

<script>
  import AssetPairSelector from '@/components/AssetPairSelector.vue'
  import Header from '@/components/Header.vue'
  import Main from '@/components/Main.vue'
  // import UserPanel from '@/components/UserPanel.vue'

  export default {
    components: {
      AssetPairSelector,
      AppHeader: Header,
      AppMain: Main,
      // UserPanel
    }
  }
</script>

<style lang="sass">
  @import "@/assets/styles/variables.sass"
  @import "@/assets/styles/index.sass"
  @import "@/assets/styles/mixins/scrollbar.sass"

  html, body
    height: 100vh
    margin: 0
    padding: 0

  body
    overflow-x: hidden
    background-color: white

    +scrollbar

  *
    box-sizing: border-box
    transition: 0.15s
    user-select: none

  #app
    width: 100%

  .app-main
    margin-top: $header-height
    margin-left: $asset-selector-width
</style>
